import { Client, ScenarioSettings } from "src/types";
import { getTaxRate, yearRange } from "../../utils";
import MainChart from ".././Charts/MainChart";
import Header from "../Report/Header";
import { useScenario } from "src/hooks/useScenario";
import { useUser } from "src/hooks/useUser";

interface MapChartProps {
  settings: ScenarioSettings;
  client: Client;
  print?: boolean;
}

const GroupedChart = ({ settings, client, print }: MapChartProps) => {
  const incomes = settings.incomes.filter((inc) => inc.enabled);
  const startYear = new Date().getFullYear();
  const { user } = useUser();
  const { scenario } = useScenario();

  const groupedIncomesByTaxType = settings.incomes.reduce(
    (acc, income) => {
      const key = income.taxType || "Taxable";
      if (!acc[key]) acc[key] = [];
      acc[key].push(income);
      return acc;
    },
    { Taxable: [], "Tax-Deferred": [], "Tax-Free": [] } as any,
  );

  return (
    <div className={`bg-white ${!print && "pb-5"} ${print && "mr-5"}`}>
      <Header client={client as any} scenario={settings} page="Incomes" />
      <MainChart
        years={yearRange(startYear, startYear + settings.maxYearsShown - 1)}
        spending={false}
        initialHeight={print ? 660 : 550}
        longevityFlag={!!user?.info?.longevityFlag}
        people={client.people}
        lineData={[]}
        taxes={[]}
        stability={!!user?.info?.stabilityRatioFlag}
        needsFlag={false}
        customColors={{
          "Tax-Free": "#b9f8cf",
          "Tax-Deferred": "#fccee8",
          "Social Security": "#bedbff",
          Taxable: "#e2e8f0",
        }}
        stackedData={[
          ...Object.keys(groupedIncomesByTaxType).map((key) => {
            return {
              name: key,
              stable: true,
              values: yearRange(
                startYear,
                startYear + settings.maxYearsShown - 1,
              ).map((year) => {
                const income = (taxType: string) =>
                  incomes
                    .filter(
                      (income) =>
                        income.taxType === taxType ||
                        (!income.taxType && taxType === "Taxable"),
                    )
                    .map((income) => scenario[year]?.incomes[income.id]?.amount)
                    .filter((t) => typeof t === "number")
                    .reduce((a: any, b: any) => a + b, 0);
                const taxRate = getTaxRate(user, settings, year);
                return income(key) * (1 - taxRate);
              }),
            };
          }),
        ]}
      />
    </div>
  );
};

export default GroupedChart;
